/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetPersonsByIdQueryResponse, WebAppGetPersonsByIdPathParams, WebAppGetPersonsById401, WebAppGetPersonsById403, WebAppGetPersonsById404 } from "../models/WebAppGetPersonsById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetPersonsById } from "../axios/webAppGetPersonsById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetPersonsByIdQueryKey = (personId: WebAppGetPersonsByIdPathParams["personId"]) => ["api-v2", { url: '/web-app/v1/persons/:personId', params: {personId:personId} }] as const

export type WebAppGetPersonsByIdQueryKey = ReturnType<typeof webAppGetPersonsByIdQueryKey>

export function webAppGetPersonsByIdQueryOptions(personId: WebAppGetPersonsByIdPathParams["personId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetPersonsByIdQueryKey(personId)
        return queryOptions<WebAppGetPersonsByIdQueryResponse, ResponseErrorConfig<WebAppGetPersonsById401 | WebAppGetPersonsById403 | WebAppGetPersonsById404>, WebAppGetPersonsByIdQueryResponse, typeof queryKey>({
         enabled: !!(personId),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetPersonsById(personId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves a single person by id.
 * @summary Get person by id
 * {@link /web-app/v1/persons/:personId}
 */
export function useWebAppGetPersonsById<TData = WebAppGetPersonsByIdQueryResponse, TQueryData = WebAppGetPersonsByIdQueryResponse, TQueryKey extends QueryKey = WebAppGetPersonsByIdQueryKey>(personId: WebAppGetPersonsByIdPathParams["personId"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetPersonsByIdQueryResponse, ResponseErrorConfig<WebAppGetPersonsById401 | WebAppGetPersonsById403 | WebAppGetPersonsById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetPersonsByIdQueryKey(personId)
         

         const query = useQuery({
          ...webAppGetPersonsByIdQueryOptions(personId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetPersonsById401 | WebAppGetPersonsById403 | WebAppGetPersonsById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}